import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M1 11.993q.027 1.49.136 2.484a2.504 2.504 0 0 0 2.211 2.217q.315.035.646.066v1.73a1.498 1.498 0 0 0 2.552 1.072l2.613-2.575q.37.003.752.003 3.929 0 6.728-.302a2.504 2.504 0 0 0 2.217-2.22q.143-1.31.143-3.478a44 44 0 0 0-.126-3.563 3.506 3.506 0 0 0-3.181-3.207A65 65 0 0 0 11.996 4v1.004q1.811.057 3.607.215a2.504 2.504 0 0 1 2.272 2.29q.123 1.48.123 3.481 0 2.12-.137 3.369a1.5 1.5 0 0 1-1.33 1.331q-2.742.297-6.621.297-.485 0-.95-.004a.5.5 0 0 0-.355.143l-2.761 2.721a.5.5 0 0 1-.85-.358V16.3a.5.5 0 0 0-.46-.499q-.562-.045-1.077-.103a1.5 1.5 0 0 1-1.327-1.33A27 27 0 0 1 2 11.993z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12.396 19.014h1.6q.431 0 .854-.004l2.597 2.558a1.5 1.5 0 0 0 2.122-.018c.275-.281.43-.66.43-1.055v-1.729q.33-.03.645-.065a2.504 2.504 0 0 0 2.212-2.218Q23 15.172 23 12.996q0-2.04-.126-3.567a3.51 3.51 0 0 0-2.213-2.978.502.502 0 0 0-.364.934 2.51 2.51 0 0 1 1.58 2.128q.123 1.48.123 3.483 0 2.127-.139 3.377a1.5 1.5 0 0 1-1.326 1.33q-.514.057-1.078.104a.5.5 0 0 0-.459.5v2.188a.5.5 0 0 1-.85.358l-2.745-2.705a.5.5 0 0 0-.357-.143q-.518.006-1.05.006h-1.6a971 971 0 0 0-2.902 0 .5.5 0 0 0 .002 1.003z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FF5C39",
      fillRule: "evenodd",
      stroke: "#FF5C39",
      strokeWidth: 0.4,
      d: "M1 7a5 5 0 1 1 10 0A5 5 0 0 1 1 7Zm.5 0a4.48 4.48 0 0 0 1.144 2.998c.001.001 6.36-6.349 6.359-6.35A4.5 4.5 0 0 0 1.5 7Zm4.503 4.498A4.5 4.5 0 0 0 9.359 4c-.001-.001-6.36 6.349-6.359 6.35a4.48 4.48 0 0 0 3.003 1.148Z",
      clipRule: "evenodd"
    }
  )
);
var SvgMessageDisabledOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MessageDisabledOutlined_default = SvgMessageDisabledOutlined;

export { MessageDisabledOutlined_default as default };
